export const cacheConfig = {
    typePolicies: {
        AdsManagerAdSet: {
            keyFields: ['db_id'],
        },
        // Query.AdAsset is an id-less namespace object shared by several queries (adAsset, adAssets, videoFrames);
        // without merging, each write replaces it and evicts the other queries' data, forcing refetch loops.
        AdAsset: {
            merge: true,
        },
    },
}
